
import Vue from 'vue'

const locales = {keys(){return []}}
global['____40009E5____'] = true;
delete global['____40009E5____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"加载中...","navigationBarBackgroundColor":"#fff","backgroundColor":"#F8F8F8","titleNView":false},"tabBar":{"color":"#282828","selectedColor":"#fcc800","borderStyle":"white","backgroundColor":"#ffffff","list":[{"pagePath":"pages/index/index","iconPath":"static/images/1-001.png","selectedIconPath":"static/images/1-002.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/goods_cate/goods_cate","iconPath":"static/images/2-001.png","selectedIconPath":"static/images/2-002.png","text":"分类","redDot":false,"badge":""},{"pagePath":"pages/plant_grass/index","iconPath":"static/images/5-001.png","selectedIconPath":"static/images/5-002.png","text":"逛逛","redDot":false,"badge":""},{"pagePath":"pages/order_addcart/order_addcart","iconPath":"static/images/3-001.png","selectedIconPath":"static/images/3-002.png","text":"购物车","redDot":false,"badge":""},{"pagePath":"pages/user/index","iconPath":"static/images/4-001.png","selectedIconPath":"static/images/4-002.png","text":"我的","redDot":false,"badge":""}]},"condition":{"current":0,"list":[{"name":"","path":"","query":""}]},"sitemapLocation":"sitemap.json"};
global.__uniConfig.compilerVersion = '4.66';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__40009E5';
global.__uniConfig.appName = 'CRMEB';
global.__uniConfig.appVersion = '1.0.4';
global.__uniConfig.appVersionCode = '127';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"SMJBZ-WCHK4-ZPZUA-DSIXI-XDDVQ-XWFX7"},"tencent":{"key":"A75BZ-ZKRKZ-LHDXC-ZITUS-UCLBF-2DFQS"}}};
global.__uniConfig.qqMapKey = "A75BZ-ZKRKZ-LHDXC-ZITUS-UCLBF-2DFQS";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-guide-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/guide/index"+'.vue')), 'pages-guide-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_addcart-order_addcart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_addcart/order_addcart"+'.vue')), 'pages-order_addcart-order_addcart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plant_grass-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plant_grass/index"+'.vue')), 'pages-plant_grass-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/user/index"+'.vue')), 'pages-user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-checkLogin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/user/checkLogin"+'.vue')), 'pages-user-checkLogin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-small_page-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/small_page/index"+'.vue')), 'pages-small_page-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_recommend-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/goods_recommend/index"+'.vue')), 'pages-goods_recommend-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_cate-goods_cate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/goods_cate/goods_cate"+'.vue')), 'pages-goods_cate-goods_cate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-news_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/news_list/index"+'.vue')), 'pages-news_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-news_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/news_details/index"+'.vue')), 'pages-news_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-auth-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/auth/index"+'.vue')), 'pages-auth-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_pay_status-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_pay_status/index"+'.vue')), 'pages-order_pay_status-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-error-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/error/index"+'.vue')), 'pages-error-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_pay_back-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_pay_back/index"+'.vue')), 'pages-order_pay_back-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-callback', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order/callback"+'.vue')), 'pages-order-callback'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-retrievePassword-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/retrievePassword/index"+'.vue')), 'pages-users-retrievePassword-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_setting-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_setting/index"+'.vue')), 'pages-users-user_setting-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_about-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_about/index"+'.vue')), 'pages-users-user_about-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-agreement_rules-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/agreement_rules/index"+'.vue')), 'pages-users-agreement_rules-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_info-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_info/index"+'.vue')), 'pages-users-user_info-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_info_form-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_info_form/index"+'.vue')), 'pages-users-user_info_form-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_nickname-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_nickname/index"+'.vue')), 'pages-users-user_nickname-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_get_coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_get_coupon/index"+'.vue')), 'pages-users-user_get_coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_goods_collection-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_goods_collection/index"+'.vue')), 'pages-users-user_goods_collection-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_sgin-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_sgin/index"+'.vue')), 'pages-users-user_sgin-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_sgin_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_sgin_list/index"+'.vue')), 'pages-users-user_sgin_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_money-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_money/index"+'.vue')), 'pages-users-user_money-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_bill-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_bill/index"+'.vue')), 'pages-users-user_bill-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_integral-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_integral/index"+'.vue')), 'pages-users-user_integral-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_brokerage-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_brokerage/index"+'.vue')), 'pages-users-user_brokerage-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_grade-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_grade/index"+'.vue')), 'pages-users-user_grade-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_grade_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_grade_list/index"+'.vue')), 'pages-users-user_grade_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_coupon/index"+'.vue')), 'pages-users-user_coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_coupon-exchange', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_coupon/exchange"+'.vue')), 'pages-users-user_coupon-exchange'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_spread_user/index"+'.vue')), 'pages-users-user_spread_user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_code-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_spread_code/index"+'.vue')), 'pages-users-user_spread_code-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_money-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_spread_money/index"+'.vue')), 'pages-users-user_spread_money-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_money-receiving', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_spread_money/receiving"+'.vue')), 'pages-users-user_spread_money-receiving'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_cash-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_cash/index"+'.vue')), 'pages-users-user_cash-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_address_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_address_list/index"+'.vue')), 'pages-users-user_address_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_address-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_address/index"+'.vue')), 'pages-users-user_address-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_phone-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_phone/index"+'.vue')), 'pages-users-user_phone-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_modify_phone-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_modify_phone/index"+'.vue')), 'pages-users-user_modify_phone-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_modify_pwd-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_modify_pwd/index"+'.vue')), 'pages-users-user_modify_pwd-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_payment-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_payment/index"+'.vue')), 'pages-users-user_payment-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_pwd_edit-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_pwd_edit/index"+'.vue')), 'pages-users-user_pwd_edit-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-order_confirm-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/order_confirm/index"+'.vue')), 'pages-users-order_confirm-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-order_payment-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/order_payment/index"+'.vue')), 'pages-users-order_payment-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/promoter-list/index"+'.vue')), 'pages-users-promoter-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/promoter-order/index"+'.vue')), 'pages-users-promoter-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter_rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/promoter_rank/index"+'.vue')), 'pages-users-promoter_rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-commission_rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/commission_rank/index"+'.vue')), 'pages-users-commission_rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-order_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/order_list/index"+'.vue')), 'pages-users-order_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-order_list-search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/order_list/search"+'.vue')), 'pages-users-order_list-search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-presell_order_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/presell_order_list/index"+'.vue')), 'pages-users-presell_order_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-goods_logistics-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/goods_logistics/index"+'.vue')), 'pages-users-goods_logistics-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_return_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_return_list/index"+'.vue')), 'pages-users-user_return_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-goods_return-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/goods_return/index"+'.vue')), 'pages-users-goods_return-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/login/index"+'.vue')), 'pages-users-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-wechat_login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/wechat_login/index"+'.vue')), 'pages-users-wechat_login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-goods_comment_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/goods_comment_list/index"+'.vue')), 'pages-users-goods_comment_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-goods_comment_con-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/goods_comment_con/index"+'.vue')), 'pages-users-goods_comment_con-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-feedback-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/feedback/index"+'.vue')), 'pages-users-feedback-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-feedback-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/feedback/list"+'.vue')), 'pages-users-feedback-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-feedback-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/feedback/detail"+'.vue')), 'pages-users-feedback-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/index"+'.vue')), 'pages-users-refund-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-confirm', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/confirm"+'.vue')), 'pages-users-refund-confirm'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/detail"+'.vue')), 'pages-users-refund-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-select', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/select"+'.vue')), 'pages-users-refund-select'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-goods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/goods/index"+'.vue')), 'pages-users-refund-goods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/list"+'.vue')), 'pages-users-refund-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-refund-logistics', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/refund/logistics"+'.vue')), 'pages-users-refund-logistics'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-browsingHistory-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/browsingHistory/index"+'.vue')), 'pages-users-browsingHistory-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-distributor-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/distributor/index"+'.vue')), 'pages-users-distributor-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_invoice_list/index"+'.vue')), 'pages-users-user_invoice_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_form-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_invoice_form/index"+'.vue')), 'pages-users-user_invoice_form-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoicing-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_invoicing/index"+'.vue')), 'pages-users-user_invoicing-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/user_invoice_order/index"+'.vue')), 'pages-users-user_invoice_order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-privacy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/users/privacy/index"+'.vue')), 'pages-users-privacy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/index"+'.vue')), 'pages-store-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/home/index"+'.vue')), 'pages-store-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/detail/index"+'.vue')), 'pages-store-detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/list/index"+'.vue')), 'pages-store-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-settled-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/settled/index"+'.vue')), 'pages-store-settled-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-applicationRecord-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/applicationRecord/index"+'.vue')), 'pages-store-applicationRecord-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-merchantDetails-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/merchantDetails/index"+'.vue')), 'pages-store-merchantDetails-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-shopStreet-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/shopStreet/index"+'.vue')), 'pages-store-shopStreet-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-store-qualifications-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/store/qualifications/index"+'.vue')), 'pages-store-qualifications-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/order/index"+'.vue')), 'pages-admin-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-orderList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/orderList/index"+'.vue')), 'pages-admin-orderList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-orderRefund-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/orderRefund/index"+'.vue')), 'pages-admin-orderRefund-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-refundList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/refundList/index"+'.vue')), 'pages-admin-refundList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-business-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/business/index"+'.vue')), 'pages-admin-business-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-orderDetail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/orderDetail/index"+'.vue')), 'pages-admin-orderDetail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-refundDetail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/refundDetail/index"+'.vue')), 'pages-admin-refundDetail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-delivery-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/delivery/index"+'.vue')), 'pages-admin-delivery-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-statistics-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/statistics/index"+'.vue')), 'pages-admin-statistics-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-order_cancellation-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/order_cancellation/index"+'.vue')), 'pages-admin-order_cancellation-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-cancellate_result-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/cancellate_result/index"+'.vue')), 'pages-admin-cancellate_result-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-goods_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/goods_details/index"+'.vue')), 'pages-admin-goods_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-system_form-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/system_form/index"+'.vue')), 'pages-admin-system_form-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-storeDiy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/storeDiy/index"+'.vue')), 'pages-admin-storeDiy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-scan-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/admin/scan/index"+'.vue')), 'pages-admin-scan-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/goods_details/index"+'.vue')), 'pages-goods_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_details/index"+'.vue')), 'pages-order_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_details-stay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_details/stay"+'.vue')), 'pages-order_details-stay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_details-delivery', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/order_details/delivery"+'.vue')), 'pages-order_details-delivery'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/list/index"+'.vue')), 'pages-product-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-goodsOnSale-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/goodsOnSale/index"+'.vue')), 'pages-product-goodsOnSale-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-soldOutGoods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/soldOutGoods/index"+'.vue')), 'pages-product-soldOutGoods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-recycleBin-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/recycleBin/index"+'.vue')), 'pages-product-recycleBin-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-storeClassification-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/storeClassification/index"+'.vue')), 'pages-product-storeClassification-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-storeClassification-addStoreClass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/storeClassification/addStoreClass"+'.vue')), 'pages-product-storeClassification-addStoreClass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/index"+'.vue')), 'pages-product-addGoods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-secound', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/secound"+'.vue')), 'pages-product-addGoods-secound'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-addGoodDetils', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/addGoodDetils"+'.vue')), 'pages-product-addGoods-addGoodDetils'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-singleSpecification', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/singleSpecification"+'.vue')), 'pages-product-addGoods-singleSpecification'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-mulSpecification', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/mulSpecification"+'.vue')), 'pages-product-addGoods-mulSpecification'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-specificationProperties', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/specificationProperties"+'.vue')), 'pages-product-addGoods-specificationProperties'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-freightTemplate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/freightTemplate"+'.vue')), 'pages-product-addGoods-freightTemplate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-addFreightTemplate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/addFreightTemplate"+'.vue')), 'pages-product-addGoods-addFreightTemplate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-product-addGoods-modifyPrice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/product/addGoods/modifyPrice"+'.vue')), 'pages-product-addGoods-modifyPrice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_detail/index"+'.vue')), 'pages-plantGrass-plant_detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_release-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_release/index"+'.vue')), 'pages-plantGrass-plant_release-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_show-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_show/index"+'.vue')), 'pages-plantGrass-plant_show-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_topic-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_topic/index"+'.vue')), 'pages-plantGrass-plant_topic-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_search/index"+'.vue')), 'pages-plantGrass-plant_search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_search_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_search_list/index"+'.vue')), 'pages-plantGrass-plant_search_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_featured-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_featured/index"+'.vue')), 'pages-plantGrass-plant_featured-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_user/index"+'.vue')), 'pages-plantGrass-plant_user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_user_attention-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_user_attention/index"+'.vue')), 'pages-plantGrass-plant_user_attention-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-plantGrass-plant_user_fans-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/plantGrass/plant_user_fans/index"+'.vue')), 'pages-plantGrass-plant_user_fans-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-HotNewGoods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/columnGoods/HotNewGoods/index"+'.vue')), 'pages-columnGoods-HotNewGoods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-goods_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/columnGoods/goods_list/index"+'.vue')), 'pages-columnGoods-goods_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-goods_coupon_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/columnGoods/goods_coupon_list/index"+'.vue')), 'pages-columnGoods-goods_coupon_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-goods_search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/columnGoods/goods_search/index"+'.vue')), 'pages-columnGoods-goods_search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-goods_search_con-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/columnGoods/goods_search_con/index"+'.vue')), 'pages-columnGoods-goods_search_con-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-customer_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/chat/customer_list/index"+'.vue')), 'pages-chat-customer_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-customer_list-chat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/chat/customer_list/chat"+'.vue')), 'pages-chat-customer_list-chat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-customer_login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/chat/customer_login/index"+'.vue')), 'pages-chat-customer_login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chat-customer_info-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/chat/customer_info/index"+'.vue')), 'pages-chat-customer_info-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_seckill-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/goods_seckill/index"+'.vue')), 'pages-activity-goods_seckill-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_seckill_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/goods_seckill_details/index"+'.vue')), 'pages-activity-goods_seckill_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-liveBroadcast-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/liveBroadcast/index"+'.vue')), 'pages-activity-liveBroadcast-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-presell-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/presell/index"+'.vue')), 'pages-activity-presell-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-presell_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/presell_details/index"+'.vue')), 'pages-activity-presell_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-combination-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/combination/index"+'.vue')), 'pages-activity-combination-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-combination_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/combination_details/index"+'.vue')), 'pages-activity-combination_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-combination_status-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/combination_status/index"+'.vue')), 'pages-activity-combination_status-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-assist-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/assist/index"+'.vue')), 'pages-activity-assist-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-assist_detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/assist_detail/index"+'.vue')), 'pages-activity-assist_detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-assist_record-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/assist_record/index"+'.vue')), 'pages-activity-assist_record-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-topic-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/topic/index"+'.vue')), 'pages-activity-topic-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-topic_detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/topic_detail/index"+'.vue')), 'pages-activity-topic_detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-lifeService-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/lifeService/index"+'.vue')), 'pages-activity-lifeService-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-collect_coupons-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/collect_coupons/index"+'.vue')), 'pages-activity-collect_coupons-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/rank/index"+'.vue')), 'pages-activity-rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-registrate_activity-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/registrate_activity/index"+'.vue')), 'pages-activity-registrate_activity-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-registrate_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/registrate_list/index"+'.vue')), 'pages-activity-registrate_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-my_registrate-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/activity/my_registrate/index"+'.vue')), 'pages-activity-my_registrate-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-short_video-nvueSwiper-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/short_video/nvueSwiper/index"+'.nvue')), 'pages-short_video-nvueSwiper-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/index"+'.vue')), 'pages-points_mall-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_goods_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/integral_goods_list"+'.vue')), 'pages-points_mall-integral_goods_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-goods_selection', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/goods_selection"+'.vue')), 'pages-points_mall-goods_selection'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_goods_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/integral_goods_details"+'.vue')), 'pages-points_mall-integral_goods_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/integral_order"+'.vue')), 'pages-points_mall-integral_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-exchange_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/exchange_record"+'.vue')), 'pages-points_mall-exchange_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_order_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/points_mall/integral_order_details"+'.vue')), 'pages-points_mall-integral_order_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-web_view-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/annex/web_view/index"+'.vue')), 'pages-annex-web_view-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_paid-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/annex/vip_paid/index"+'.vue')), 'pages-annex-vip_paid-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_center-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/annex/vip_center/index"+'.vue')), 'pages-annex-vip_center-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_clause-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/jackshell/Desktop/ShellsValue/kmm-market/v3-uni-app/pages/annex/vip_clause/index"+'.vue')), 'pages-annex-vip_clause-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/guide/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"开屏广告","navigationStyle":"custom","disableScroll":true,"titleNView":false})
      },
      [
        createElement('pages-guide-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-guide-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/guide/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"首页","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/order_addcart/order_addcart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-order_addcart-order_addcart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-order_addcart-order_addcart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_addcart/order_addcart',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/plant_grass/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"种草社区"})
      },
      [
        createElement('pages-plant_grass-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-plant_grass-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plant_grass/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:4
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"个人中心","navigationStyle":"custom"})
      },
      [
        createElement('pages-user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/index',
isQuit:true,
isTabBar:true,
tabBarIndex:4,
  windowTop:0
}
},
{
path: '/pages/user/checkLogin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录验证"})
      },
      [
        createElement('pages-user-checkLogin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-checkLogin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/checkLogin',
  windowTop:0
}
},
{
path: '/pages/small_page/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"微页面"})
      },
      [
        createElement('pages-small_page-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-small_page-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/small_page/index',
  windowTop:0
}
},
{
path: '/pages/goods_recommend/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"商品推荐"})
      },
      [
        createElement('pages-goods_recommend-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_recommend-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_recommend/index',
  windowTop:0
}
},
{
path: '/pages/goods_cate/goods_cate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"商品分类"})
      },
      [
        createElement('pages-goods_cate-goods_cate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:6,
  name:'pages-goods_cate-goods_cate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_cate/goods_cate',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/news_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资讯","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-news_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-news_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/news_list/index',
  windowTop:0
}
},
{
path: '/pages/news_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资讯详情"})
      },
      [
        createElement('pages-news_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-news_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/news_details/index',
  windowTop:0
}
},
{
path: '/pages/auth/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"加载中"})
      },
      [
        createElement('pages-auth-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-auth-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/auth/index',
  windowTop:0
}
},
{
path: '/pages/order_pay_status/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付状态"})
      },
      [
        createElement('pages-order_pay_status-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_pay_status-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_pay_status/index',
  windowTop:0
}
},
{
path: '/pages/error/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"网站已关闭"})
      },
      [
        createElement('pages-error-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-error-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/error/index',
  windowTop:0
}
},
{
path: '/pages/order_pay_back/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付提示"})
      },
      [
        createElement('pages-order_pay_back-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_pay_back-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_pay_back/index',
  windowTop:0
}
},
{
path: '/pages/order/callback',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付校验"})
      },
      [
        createElement('pages-order-callback', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-callback',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/callback',
  windowTop:0
}
},
{
path: '/pages/users/retrievePassword/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码"})
      },
      [
        createElement('pages-users-retrievePassword-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-retrievePassword-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/retrievePassword/index',
  windowTop:0
}
},
{
path: '/pages/users/user_setting/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pages-users-user_setting-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_setting-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_setting/index',
  windowTop:0
}
},
{
path: '/pages/users/user_about/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-users-user_about-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_about-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_about/index',
  windowTop:0
}
},
{
path: '/pages/users/agreement_rules/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"协议规则"})
      },
      [
        createElement('pages-users-agreement_rules-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-agreement_rules-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/agreement_rules/index',
  windowTop:0
}
},
{
path: '/pages/users/user_info/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pages-users-user_info-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_info-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_info/index',
  windowTop:0
}
},
{
path: '/pages/users/user_info_form/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人资料"})
      },
      [
        createElement('pages-users-user_info_form-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_info_form-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_info_form/index',
  windowTop:0
}
},
{
path: '/pages/users/user_nickname/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"昵称"})
      },
      [
        createElement('pages-users-user_nickname-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_nickname-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_nickname/index',
  windowTop:0
}
},
{
path: '/pages/users/user_get_coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取优惠券"})
      },
      [
        createElement('pages-users-user_get_coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_get_coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_get_coupon/index',
  windowTop:0
}
},
{
path: '/pages/users/user_goods_collection/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的收藏"})
      },
      [
        createElement('pages-users-user_goods_collection-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_goods_collection-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_goods_collection/index',
  windowTop:0
}
},
{
path: '/pages/users/user_sgin/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"签到"})
      },
      [
        createElement('pages-users-user_sgin-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_sgin-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_sgin/index',
  windowTop:0
}
},
{
path: '/pages/users/user_sgin_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到记录"})
      },
      [
        createElement('pages-users-user_sgin_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_sgin_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_sgin_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_money/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的账户"})
      },
      [
        createElement('pages-users-user_money-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_money-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_money/index',
  windowTop:0
}
},
{
path: '/pages/users/user_bill/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账单明细"})
      },
      [
        createElement('pages-users-user_bill-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_bill-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_bill/index',
  windowTop:0
}
},
{
path: '/pages/users/user_integral/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的积分"})
      },
      [
        createElement('pages-users-user_integral-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_integral-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_integral/index',
  windowTop:0
}
},
{
path: '/pages/users/user_brokerage/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销等级"})
      },
      [
        createElement('pages-users-user_brokerage-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_brokerage-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_brokerage/index',
  windowTop:0
}
},
{
path: '/pages/users/user_grade/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的等级","navigationBarBackgroundColor":"#282828"})
      },
      [
        createElement('pages-users-user_grade-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_grade-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_grade/index',
  windowTop:0
}
},
{
path: '/pages/users/user_grade_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"成长值记录","navigationBarBackgroundColor":"#282828"})
      },
      [
        createElement('pages-users-user_grade_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_grade_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_grade_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('pages-users-user_coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_coupon/index',
  windowTop:0
}
},
{
path: '/pages/users/user_coupon/exchange',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"卡密兑换"})
      },
      [
        createElement('pages-users-user_coupon-exchange', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_coupon-exchange',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_coupon/exchange',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的推广"})
      },
      [
        createElement('pages-users-user_spread_user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_user/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_code/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销海报"})
      },
      [
        createElement('pages-users-user_spread_code-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_code-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_code/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_money/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金记录"})
      },
      [
        createElement('pages-users-user_spread_money-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_money-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_money/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_money/receiving',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款"})
      },
      [
        createElement('pages-users-user_spread_money-receiving', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_money-receiving',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_money/receiving',
  windowTop:0
}
},
{
path: '/pages/users/user_cash/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"提现"})
      },
      [
        createElement('pages-users-user_cash-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_cash-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_cash/index',
  windowTop:0
}
},
{
path: '/pages/users/user_address_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"地址管理"})
      },
      [
        createElement('pages-users-user_address_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_address_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_address_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_address/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加地址"})
      },
      [
        createElement('pages-users-user_address-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_address-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_address/index',
  windowTop:0
}
},
{
path: '/pages/users/user_phone/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机"})
      },
      [
        createElement('pages-users-user_phone-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_phone-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_phone/index',
  windowTop:0
}
},
{
path: '/pages/users/user_modify_phone/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改手机号"})
      },
      [
        createElement('pages-users-user_modify_phone-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_modify_phone-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_modify_phone/index',
  windowTop:0
}
},
{
path: '/pages/users/user_modify_pwd/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码"})
      },
      [
        createElement('pages-users-user_modify_pwd-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_modify_pwd-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_modify_pwd/index',
  windowTop:0
}
},
{
path: '/pages/users/user_payment/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"余额充值"})
      },
      [
        createElement('pages-users-user_payment-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_payment-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_payment/index',
  windowTop:0
}
},
{
path: '/pages/users/user_pwd_edit/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码"})
      },
      [
        createElement('pages-users-user_pwd_edit-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_pwd_edit-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_pwd_edit/index',
  windowTop:0
}
},
{
path: '/pages/users/order_confirm/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-users-order_confirm-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-order_confirm-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/order_confirm/index',
  windowTop:0
}
},
{
path: '/pages/users/order_payment/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单支付"})
      },
      [
        createElement('pages-users-order_payment-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-order_payment-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/order_payment/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter-list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人统计"})
      },
      [
        createElement('pages-users-promoter-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter-list/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter-order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人订单"})
      },
      [
        createElement('pages-users-promoter-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter-order/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter_rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人排行"})
      },
      [
        createElement('pages-users-promoter_rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter_rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter_rank/index',
  windowTop:0
}
},
{
path: '/pages/users/commission_rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金排行"})
      },
      [
        createElement('pages-users-commission_rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-commission_rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/commission_rank/index',
  windowTop:0
}
},
{
path: '/pages/users/order_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单","navigationStyle":"custom"})
      },
      [
        createElement('pages-users-order_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-order_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/order_list/index',
  windowTop:0
}
},
{
path: '/pages/users/order_list/search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单"})
      },
      [
        createElement('pages-users-order_list-search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-order_list-search',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/order_list/search',
  windowTop:0
}
},
{
path: '/pages/users/presell_order_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预售订单"})
      },
      [
        createElement('pages-users-presell_order_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-presell_order_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/presell_order_list/index',
  windowTop:0
}
},
{
path: '/pages/users/goods_logistics/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物流信息"})
      },
      [
        createElement('pages-users-goods_logistics-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-goods_logistics-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/goods_logistics/index',
  windowTop:0
}
},
{
path: '/pages/users/user_return_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货列表"})
      },
      [
        createElement('pages-users-user_return_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_return_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_return_list/index',
  windowTop:0
}
},
{
path: '/pages/users/goods_return/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退货"})
      },
      [
        createElement('pages-users-goods_return-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-goods_return-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/goods_return/index',
  windowTop:0
}
},
{
path: '/pages/users/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-users-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/login/index',
  windowTop:0
}
},
{
path: '/pages/users/wechat_login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pages-users-wechat_login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-wechat_login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/wechat_login/index',
  windowTop:0
}
},
{
path: '/pages/users/goods_comment_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"backgroundColor":"#FFFFFF","navigationBarTitleText":"商品评分"})
      },
      [
        createElement('pages-users-goods_comment_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-goods_comment_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/goods_comment_list/index',
  windowTop:0
}
},
{
path: '/pages/users/goods_comment_con/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('pages-users-goods_comment_con-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-goods_comment_con-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/goods_comment_con/index',
  windowTop:0
}
},
{
path: '/pages/users/feedback/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"问题反馈","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-feedback-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-feedback-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/feedback/index',
  windowTop:0
}
},
{
path: '/pages/users/feedback/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"反馈记录","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-feedback-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-feedback-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/feedback/list',
  windowTop:0
}
},
{
path: '/pages/users/feedback/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"反馈内容","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-feedback-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-feedback-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/feedback/detail',
  windowTop:0
}
},
{
path: '/pages/users/refund/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"批量退款","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/index',
  windowTop:0
}
},
{
path: '/pages/users/refund/confirm',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退款","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-confirm', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-confirm',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/confirm',
  windowTop:0
}
},
{
path: '/pages/users/refund/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退款详情","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/detail',
  windowTop:0
}
},
{
path: '/pages/users/refund/select',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择服务类型","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-select', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-select',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/select',
  windowTop:0
}
},
{
path: '/pages/users/refund/goods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货退款","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-goods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-goods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/goods/index',
  windowTop:0
}
},
{
path: '/pages/users/refund/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货列表","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/list',
  windowTop:0
}
},
{
path: '/pages/users/refund/logistics',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物流信息","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-refund-logistics', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-refund-logistics',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/refund/logistics',
  windowTop:0
}
},
{
path: '/pages/users/browsingHistory/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"浏览记录","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-browsingHistory-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-browsingHistory-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/browsingHistory/index',
  windowTop:0
}
},
{
path: '/pages/users/distributor/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"成为分销","navigationStyle":"custom","backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-distributor-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-distributor-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/distributor/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发票管理"})
      },
      [
        createElement('pages-users-user_invoice_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_form/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加新发票"})
      },
      [
        createElement('pages-users-user_invoice_form-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_form-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_form/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoicing/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"开具发票"})
      },
      [
        createElement('pages-users-user_invoicing-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoicing-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoicing/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-users-user_invoice_order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_order/index',
  windowTop:0
}
},
{
path: '/pages/users/privacy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-users-privacy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-privacy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/privacy/index',
  windowTop:0
}
},
{
path: '/pages/store/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"店铺diy首页"})
      },
      [
        createElement('pages-store-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/index',
  windowTop:0
}
},
{
path: '/pages/store/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"店铺首页"})
      },
      [
        createElement('pages-store-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-home-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/home/index',
  windowTop:0
}
},
{
path: '/pages/store/detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"店铺详情"})
      },
      [
        createElement('pages-store-detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/detail/index',
  windowTop:0
}
},
{
path: '/pages/store/list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-store-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/list/index',
  windowTop:0
}
},
{
path: '/pages/store/settled/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"商家入驻"})
      },
      [
        createElement('pages-store-settled-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-settled-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/settled/index',
  windowTop:0
}
},
{
path: '/pages/store/applicationRecord/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请记录"})
      },
      [
        createElement('pages-store-applicationRecord-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-applicationRecord-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/applicationRecord/index',
  windowTop:0
}
},
{
path: '/pages/store/merchantDetails/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"审核通过"})
      },
      [
        createElement('pages-store-merchantDetails-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-merchantDetails-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/merchantDetails/index',
  windowTop:0
}
},
{
path: '/pages/store/shopStreet/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"店铺街"})
      },
      [
        createElement('pages-store-shopStreet-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-shopStreet-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/shopStreet/index',
  windowTop:0
}
},
{
path: '/pages/store/qualifications/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"店铺资质信息"})
      },
      [
        createElement('pages-store-qualifications-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-store-qualifications-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/store/qualifications/index',
  windowTop:0
}
},
{
path: '/pages/admin/order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单首页"})
      },
      [
        createElement('pages-admin-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/order/index',
  windowTop:0
}
},
{
path: '/pages/admin/orderList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单列表"})
      },
      [
        createElement('pages-admin-orderList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-orderList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/orderList/index',
  windowTop:0
}
},
{
path: '/pages/admin/orderRefund/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"立即退款"})
      },
      [
        createElement('pages-admin-orderRefund-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-orderRefund-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/orderRefund/index',
  windowTop:0
}
},
{
path: '/pages/admin/refundList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退款"})
      },
      [
        createElement('pages-admin-refundList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-refundList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/refundList/index',
  windowTop:0
}
},
{
path: '/pages/admin/business/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家管理"})
      },
      [
        createElement('pages-admin-business-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-business-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/business/index',
  windowTop:0
}
},
{
path: '/pages/admin/orderDetail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-admin-orderDetail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-orderDetail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/orderDetail/index',
  windowTop:0
}
},
{
path: '/pages/admin/refundDetail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退款单详情"})
      },
      [
        createElement('pages-admin-refundDetail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-refundDetail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/refundDetail/index',
  windowTop:0
}
},
{
path: '/pages/admin/delivery/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单发货"})
      },
      [
        createElement('pages-admin-delivery-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-delivery-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/delivery/index',
  windowTop:0
}
},
{
path: '/pages/admin/statistics/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单数据统计"})
      },
      [
        createElement('pages-admin-statistics-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-statistics-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/statistics/index',
  windowTop:0
}
},
{
path: '/pages/admin/order_cancellation/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单核销"})
      },
      [
        createElement('pages-admin-order_cancellation-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-order_cancellation-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/order_cancellation/index',
  windowTop:0
}
},
{
path: '/pages/admin/cancellate_result/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"核销结果"})
      },
      [
        createElement('pages-admin-cancellate_result-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-cancellate_result-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/cancellate_result/index',
  windowTop:0
}
},
{
path: '/pages/admin/goods_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-admin-goods_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-goods_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/goods_details/index',
  windowTop:0
}
},
{
path: '/pages/admin/system_form/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"系统表单"})
      },
      [
        createElement('pages-admin-system_form-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-system_form-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/system_form/index',
  windowTop:0
}
},
{
path: '/pages/admin/storeDiy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"店铺diy首页"})
      },
      [
        createElement('pages-admin-storeDiy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-storeDiy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/storeDiy/index',
  windowTop:0
}
},
{
path: '/pages/admin/scan/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手机扫码上传"})
      },
      [
        createElement('pages-admin-scan-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-scan-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/scan/index',
  windowTop:0
}
},
{
path: '/pages/goods_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-goods_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_details/index',
  windowTop:0
}
},
{
path: '/pages/order_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-order_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_details/index',
  windowTop:0
}
},
{
path: '/pages/order_details/stay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-order_details-stay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_details-stay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_details/stay',
  windowTop:0
}
},
{
path: '/pages/order_details/delivery',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"配送详情"})
      },
      [
        createElement('pages-order_details-delivery', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order_details-delivery',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_details/delivery',
  windowTop:0
}
},
{
path: '/pages/product/list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品管理"})
      },
      [
        createElement('pages-product-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/list/index',
  windowTop:0
}
},
{
path: '/pages/product/goodsOnSale/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"onReachBottomDistance":100,"navigationBarTitleText":"在售商品","enablePullDownRefresh":false})
      },
      [
        createElement('pages-product-goodsOnSale-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-goodsOnSale-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/goodsOnSale/index',
  windowTop:0
}
},
{
path: '/pages/product/soldOutGoods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"onReachBottomDistance":100,"navigationBarTitleText":"售罄商品","enablePullDownRefresh":false})
      },
      [
        createElement('pages-product-soldOutGoods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-soldOutGoods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/soldOutGoods/index',
  windowTop:0
}
},
{
path: '/pages/product/recycleBin/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"onReachBottomDistance":100,"navigationBarTitleText":"回收站","enablePullDownRefresh":false})
      },
      [
        createElement('pages-product-recycleBin-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-recycleBin-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/recycleBin/index',
  windowTop:0
}
},
{
path: '/pages/product/storeClassification/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"店铺分类"})
      },
      [
        createElement('pages-product-storeClassification-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-storeClassification-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/storeClassification/index',
  windowTop:0
}
},
{
path: '/pages/product/storeClassification/addStoreClass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加店铺分类"})
      },
      [
        createElement('pages-product-storeClassification-addStoreClass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-storeClassification-addStoreClass',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/storeClassification/addStoreClass',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加商品"})
      },
      [
        createElement('pages-product-addGoods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/index',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/secound',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加商品"})
      },
      [
        createElement('pages-product-addGoods-secound', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-secound',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/secound',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/addGoodDetils',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-product-addGoods-addGoodDetils', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-addGoodDetils',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/addGoodDetils',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/singleSpecification',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"单规格"})
      },
      [
        createElement('pages-product-addGoods-singleSpecification', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-singleSpecification',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/singleSpecification',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/mulSpecification',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"多规格"})
      },
      [
        createElement('pages-product-addGoods-mulSpecification', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-mulSpecification',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/mulSpecification',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/specificationProperties',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"规格属性"})
      },
      [
        createElement('pages-product-addGoods-specificationProperties', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-specificationProperties',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/specificationProperties',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/freightTemplate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"运费模板","onReachBottomDistance":100,"enablePullDownRefresh":false})
      },
      [
        createElement('pages-product-addGoods-freightTemplate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-freightTemplate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/freightTemplate',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/addFreightTemplate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增运费模板"})
      },
      [
        createElement('pages-product-addGoods-addFreightTemplate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-addFreightTemplate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/addFreightTemplate',
  windowTop:0
}
},
{
path: '/pages/product/addGoods/modifyPrice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改价格-多规格"})
      },
      [
        createElement('pages-product-addGoods-modifyPrice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-product-addGoods-modifyPrice',
  isNVue:false,maxWidth:0,
  pagePath:'pages/product/addGoods/modifyPrice',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"内容详情"})
      },
      [
        createElement('pages-plantGrass-plant_detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_detail/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_release/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"内容发布"})
      },
      [
        createElement('pages-plantGrass-plant_release-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_release-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_release/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_show/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"种草秀"})
      },
      [
        createElement('pages-plantGrass-plant_show-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_show-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_show/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_topic/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"话题筛选"})
      },
      [
        createElement('pages-plantGrass-plant_topic-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_topic-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_topic/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_search/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索"})
      },
      [
        createElement('pages-plantGrass-plant_search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_search-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_search/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_search_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索结果"})
      },
      [
        createElement('pages-plantGrass-plant_search_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_search_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_search_list/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_featured/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"为你精选"})
      },
      [
        createElement('pages-plantGrass-plant_featured-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_featured-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_featured/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人主页"})
      },
      [
        createElement('pages-plantGrass-plant_user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_user/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_user_attention/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的关注"})
      },
      [
        createElement('pages-plantGrass-plant_user_attention-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_user_attention-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_user_attention/index',
  windowTop:0
}
},
{
path: '/pages/plantGrass/plant_user_fans/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的粉丝"})
      },
      [
        createElement('pages-plantGrass-plant_user_fans-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-plantGrass-plant_user_fans-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/plantGrass/plant_user_fans/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/HotNewGoods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"精品推荐"})
      },
      [
        createElement('pages-columnGoods-HotNewGoods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-HotNewGoods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/HotNewGoods/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/goods_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-columnGoods-goods_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-goods_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/goods_list/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/goods_coupon_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"优惠券商品"})
      },
      [
        createElement('pages-columnGoods-goods_coupon_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-goods_coupon_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/goods_coupon_list/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/goods_search/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索商品"})
      },
      [
        createElement('pages-columnGoods-goods_search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-goods_search-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/goods_search/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/goods_search_con/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索商品"})
      },
      [
        createElement('pages-columnGoods-goods_search_con-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-goods_search_con-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/goods_search_con/index',
  windowTop:0
}
},
{
path: '/pages/chat/customer_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息中心"})
      },
      [
        createElement('pages-chat-customer_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-customer_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/customer_list/index',
  windowTop:0
}
},
{
path: '/pages/chat/customer_list/chat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客服聊天"})
      },
      [
        createElement('pages-chat-customer_list-chat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-customer_list-chat',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/customer_list/chat',
  windowTop:0
}
},
{
path: '/pages/chat/customer_login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客服登录"})
      },
      [
        createElement('pages-chat-customer_login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-customer_login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/customer_login/index',
  windowTop:0
}
},
{
path: '/pages/chat/customer_info/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"客户信息"})
      },
      [
        createElement('pages-chat-customer_info-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chat-customer_info-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chat/customer_info/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_seckill/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom","navigationBarTitleText":"限时秒杀"})
      },
      [
        createElement('pages-activity-goods_seckill-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_seckill-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_seckill/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_seckill_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"秒杀详情","navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-goods_seckill_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_seckill_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_seckill_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/liveBroadcast/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"直播列表","navigationBarBackgroundColor":"#F2F2F2"})
      },
      [
        createElement('pages-activity-liveBroadcast-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-liveBroadcast-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/liveBroadcast/index',
  windowTop:0
}
},
{
path: '/pages/activity/presell/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom","navigationBarTitleText":"预售列表"})
      },
      [
        createElement('pages-activity-presell-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-presell-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/presell/index',
  windowTop:0
}
},
{
path: '/pages/activity/presell_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预售商品详情","navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-presell_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-presell_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/presell_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/combination/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom","navigationBarTitleText":"拼团"})
      },
      [
        createElement('pages-activity-combination-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-combination-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/combination/index',
  windowTop:0
}
},
{
path: '/pages/activity/combination_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"拼团详情","navigationBarBackgroundColor":"#F2F2F2"})
      },
      [
        createElement('pages-activity-combination_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-combination_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/combination_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/combination_status/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"拼团状态"})
      },
      [
        createElement('pages-activity-combination_status-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-combination_status-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/combination_status/index',
  windowTop:0
}
},
{
path: '/pages/activity/assist/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"助力列表","navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-assist-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-assist-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/assist/index',
  windowTop:0
}
},
{
path: '/pages/activity/assist_detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"发起助力"})
      },
      [
        createElement('pages-activity-assist_detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-assist_detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/assist_detail/index',
  windowTop:0
}
},
{
path: '/pages/activity/assist_record/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"助力记录"})
      },
      [
        createElement('pages-activity-assist_record-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-assist_record-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/assist_record/index',
  windowTop:0
}
},
{
path: '/pages/activity/topic/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动专场"})
      },
      [
        createElement('pages-activity-topic-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-topic-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/topic/index',
  windowTop:0
}
},
{
path: '/pages/activity/topic_detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"主题活动"})
      },
      [
        createElement('pages-activity-topic_detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-topic_detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/topic_detail/index',
  windowTop:0
}
},
{
path: '/pages/activity/lifeService/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"本地服务"})
      },
      [
        createElement('pages-activity-lifeService-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-lifeService-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/lifeService/index',
  windowTop:0
}
},
{
path: '/pages/activity/collect_coupons/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"领劵中心"})
      },
      [
        createElement('pages-activity-collect_coupons-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-collect_coupons-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/collect_coupons/index',
  windowTop:0
}
},
{
path: '/pages/activity/rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"热卖排行"})
      },
      [
        createElement('pages-activity-rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/rank/index',
  windowTop:0
}
},
{
path: '/pages/activity/registrate_activity/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报名活动"})
      },
      [
        createElement('pages-activity-registrate_activity-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-registrate_activity-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/registrate_activity/index',
  windowTop:0
}
},
{
path: '/pages/activity/registrate_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报名活动列表"})
      },
      [
        createElement('pages-activity-registrate_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-registrate_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/registrate_list/index',
  windowTop:0
}
},
{
path: '/pages/activity/my_registrate/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的报名"})
      },
      [
        createElement('pages-activity-my_registrate-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-my_registrate-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/my_registrate/index',
  windowTop:0
}
},
{
path: '/pages/short_video/nvueSwiper/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"社区短视频","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-short_video-nvueSwiper-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-short_video-nvueSwiper-index',
  isNVue:true,maxWidth:0,
  pagePath:'pages/short_video/nvueSwiper/index',
  windowTop:0
}
},
{
path: '/pages/points_mall/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTextStyle":"white","navigationBarBackgroundColor":"#333333","navigationBarTitleText":"积分商城"})
      },
      [
        createElement('pages-points_mall-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/index',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_goods_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-points_mall-integral_goods_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_goods_list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_goods_list',
  windowTop:0
}
},
{
path: '/pages/points_mall/goods_selection',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"好物精选"})
      },
      [
        createElement('pages-points_mall-goods_selection', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-goods_selection',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/goods_selection',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_goods_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-points_mall-integral_goods_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_goods_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_goods_details',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分订单","navigationStyle":"custom"})
      },
      [
        createElement('pages-points_mall-integral_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_order',
  windowTop:0
}
},
{
path: '/pages/points_mall/exchange_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换记录"})
      },
      [
        createElement('pages-points_mall-exchange_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-exchange_record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/exchange_record',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_order_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换订单详情"})
      },
      [
        createElement('pages-points_mall-integral_order_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_order_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_order_details',
  windowTop:0
}
},
{
path: '/pages/annex/web_view/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-annex-web_view-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-web_view-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/web_view/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_paid/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"开通会员"})
      },
      [
        createElement('pages-annex-vip_paid-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_paid-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_paid/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_center/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员中心"})
      },
      [
        createElement('pages-annex-vip_center-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_center-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_center/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_clause/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员协议"})
      },
      [
        createElement('pages-annex-vip_clause-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_clause-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_clause/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
